/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { authReducer } from "./auth/authReducer";
import { errorReducer } from "./error/errorReducer";
import { realmReducer } from "./realm/realmReducer";
import { themeReducer } from "./theme/themeReducer";
import { loaderReducer } from "./loader/loaderReducer";
import { moduleReducer } from "./module/moduleReducers";
import { snackBarReducer } from "./snackBar/snackBarReducer";
import { customerReducer } from "./customer/customerReducers";
import { systemSpecReducer } from "./stystemSpec/systemSpecReducers";
import { applicationReducer } from "./application/applicationReducers";
import { organizationReducer } from "./organization/organizationReducer";
import { subEnterpriseReducer } from "./subEnterprise/subEnterpriseReducer";

export const rootReducer = combineReducers({
  error: errorReducer,
  loader: loaderReducer,
  snackBar: snackBarReducer,
  customer: customerReducer,
  organization: organizationReducer,
  subEnterprise: subEnterpriseReducer,
  realm: realmReducer,
  application: applicationReducer,
  module: moduleReducer,
  systemSpec: systemSpecReducer,
  theme: themeReducer,
  auth: authReducer,
});

export const store = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof store>;
export type AppDispatch = AppStore["dispatch"];
